import {loadable} from 'router/routes';
import {Page} from 'router/page';
import {fetchCleanedData} from 'router/router-actions';

const SpotDetailsAirport = loadable(() =>
    import('spot-details/airport/SpotDetailsAirport')
);

SpotDetailsAirport.getInitialState = async ({state: initialState, route}) => {
    const state = await fetchCleanedData({
        state: initialState,
        route,
    });

    state.searchRequest.pageType = Page.FACILITY;

    return state;
};

export default SpotDetailsAirport;
